/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_File_Too_LargeInputs */

const cs_social_export_file_too_large = /** @type {(inputs: Social_Export_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soubor překračuje limit pro nahrání.`)
};

const en_social_export_file_too_large = /** @type {(inputs: Social_Export_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File exceeds the upload limit.`)
};

/**
* | output |
* | --- |
* | "File exceeds the upload limit." |
*
* @param {Social_Export_File_Too_LargeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_file_too_large = /** @type {((inputs?: Social_Export_File_Too_LargeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_File_Too_LargeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_file_too_large(inputs)
	return cs_social_export_file_too_large(inputs)
});